<template>
  <v-app>
    <Header/>
     <Header2/> 
    <v-main>
      <!-- <HelloWorld/> -->
      <router-view/>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
// import HelloWorld from './components/page1/CardOne';
import Header from './components/Header';
import Footer from './components/Footer';
 import Header2 from './components/Header2';
import "./assets/style.css";

export default {
  name: 'App',

  components: {
    // HelloWorld,
    Header,
    Footer,
     Header2,
  },

  data: () => ({
    //
  }),
};
</script>
<style>
@font-face {
  font-family: blackerlight;
  src: url("./assets/fonts/Blacker-Display-Light-trial.ttf")
}
@font-face {
  font-family: blackerregular;
  src: url("./assets/fonts/Blacker-Display-Regular-trial.ttf")
}
@font-face {
  font-family: blackermedium;
  src: url("./assets/fonts/Blacker-Display-Medium-trial.ttf")
}
@font-face {
  font-family: blackerbold;
  src: url("./assets/fonts/Blacker-Display-Bold-trial.ttf")
}
@font-face {
  font-family: blackerextrabold;
  src: url("./assets/fonts/Blacker-Display-ExtraBold-trial.ttf")
}
@font-face {
  font-family: blackeritaliclight;
  src: url("./assets/fonts/Blacker-Display-Light-Italic-trial.ttf")
}
@font-face {
  font-family: firasansregular;
  src: url("./assets/fonts/FiraSans-Regular.ttf")
}
@font-face {
  font-family: sofiapro-light;
  src: url("./assets/fonts/sofiapro-light.otf")
}
@font-face {
  font-family: futuramedium;
  src: url("./assets/fonts/futura medium bt.ttf")
}
@font-face {
  font-family: PlayfairDisplay-Bold;
  src: url("./assets/fonts/PlayfairDisplay-Bold.ttf")
}
@font-face {
  font-family: SofiaPro-Medium;
  src: url("./assets/fonts/Sofia Pro Medium.ttf")
}
@font-face {
  font-family: poppins-bold;
  src: url("./assets/fonts/Poppins-Bold.ttf")
}
@font-face {
  font-family: poppins-semibold;
  src: url("./assets/fonts/Poppins-SemiBold.ttf")
}
@font-face {
  font-family: poppins-thin;
  src: url("./assets/fonts/Poppins-Thin.ttf")
}
@font-face {
  font-family: poppins-light;
  src: url("./assets/fonts/Poppins-Light.ttf")
}
@font-face {
  font-family: poppins-lighti;
  src: url("./assets/fonts/Poppins-LightItalic.ttf")
}
@font-face {
  font-family: poppins-regular;
  src: url("./assets/fonts/Poppins-Regular.ttf")
}
.routerlink {
  text-decoration: none;
}
</style>
